module.exports = __webpack_public_path__ + "static/media/doctor.03b3b01f.png";